'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseAlerts = require('@bibliocommons/base-alerts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NameCharacterLimitExceededAlert = function (_BcReactComponent) {
  _inherits(NameCharacterLimitExceededAlert, _BcReactComponent);

  function NameCharacterLimitExceededAlert() {
    _classCallCheck(this, NameCharacterLimitExceededAlert);

    return _possibleConstructorReturn(this, (NameCharacterLimitExceededAlert.__proto__ || Object.getPrototypeOf(NameCharacterLimitExceededAlert)).apply(this, arguments));
  }

  _createClass(NameCharacterLimitExceededAlert, [{
    key: 'focus',
    value: function focus() {
      if (this._alertWrapper) {
        this._alertWrapper.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'cp-name-character-limit-exceeded-alert' },
        _react2.default.createElement(
          'div',
          { tabIndex: '-1', ref: function ref(el) {
              return _this2._alertWrapper = el;
            } },
          _react2.default.createElement(
            _baseAlerts.AlertFailure,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_title_exceeds_max_length' })
          )
        )
      );
    }
  }]);

  return NameCharacterLimitExceededAlert;
}(_baseBcReactComponent2.default);

exports.default = NameCharacterLimitExceededAlert;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/name-character-limit-exceeded-alert/components/NameCharacterLimitExceededAlert.component.js
// module id = 1322
// module chunks = 0